import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  static setIsMobile(getScreenWidth: any) {
		if (getScreenWidth < 992) { return true; }
		else { return false; }
	}
}
